import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from './LinkedHashMap.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function eachCount(_this__u8e3s4) {
  // Inline function 'kotlin.collections.fold' call
  // Inline function 'kotlin.collections.aggregate' call
  // Inline function 'kotlin.collections.mutableMapOf' call
  // Inline function 'kotlin.collections.aggregateTo' call
  var destination = LinkedHashMap().f6();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.g6();
  while (_iterator__ex2g4s.n1()) {
    var e = _iterator__ex2g4s.o1();
    var key = _this__u8e3s4.h6(e);
    var accumulator = destination.p3(key);
    var tmp;
    if (accumulator == null && !destination.n3(key)) {
      tmp = 0;
    } else {
      tmp = (accumulator == null ? true : !(accumulator == null)) ? accumulator : THROW_CCE();
    }
    // Inline function 'kotlin.collections.set' call
    var value = tmp + 1 | 0;
    destination.s3(key, value);
  }
  return destination;
}
//region block: exports
export {
  eachCount as eachCount1imd75z0wkpbt,
};
//endregion

//# sourceMappingURL=GroupingJs.mjs.map
